angular.module('webtrader').component('marketExecution', {
  bindings: {
    collapsed: '=',
  },
  templateUrl: BASE_URL+'templates/component.marketExecution.html',
  controller: function (Quotes, Trades) {
    this.quotes = Quotes

    this.volume = 1
    this.sl = 0
    this.tp = 0
    this.inc = (val, add) => (typeof val !== 'number' || isNaN(val))? Math.abs(add) : Math.max((val + add).toFixed(2), Math.abs(add))

    this.buy = () => this.openTrade(0)
    this.sell = () => this.openTrade(1)

    this.openTrade = (cmd) => {
      Trades.order({
        cmd: cmd,
        symbol: Quotes.currentSymbol,
        volume: this.volume,
        sl: this.sl,
        tp: this.tp,
      })
    }
  }
})
